/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProjectSummaryEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const projectSummaryEntryPoint: EntryPoint<ProjectSummaryEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ProjectSummaryEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-project-summary", jiraSpaEntry: "async-servicedesk-project-summary" */ './ProjectSummaryLayout.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
